import { useCallback, useEffect } from 'react';
import storeActions from '../actions';
import storeSelectors from '../selectors';
import { useAppDispatch } from 'store/hooks';
import { IApiGetListScreensInStoreParam } from 'modules/store/interfaces/api';

const useGetPlaylistsInStore = (storeId: string, isLazy = false) => {
  const dispatch = useAppDispatch();
  const playlistsInStore = storeSelectors.getPlaylistsInStore();
  const playlistsInStoreParam = storeSelectors.getPlaylistsInStoreParam();

  const mutate = useCallback(
    (params: IApiGetListScreensInStoreParam) => {
      dispatch(storeActions.getPlaylistsInStore.fetch({ ...params, storeId }));
    },
    [dispatch, storeId],
  );

  useEffect(() => {
    if (!isLazy) {
      mutate({
        page: 1,
        size: 10,
      });
    }
  }, [mutate, isLazy]);

  return {
    playlistsInStore,
    playlistsInStoreParam,
    mutate,
  };
};

export default useGetPlaylistsInStore;
